<template>
  <div class="aiChatHistoryTable">
    <Pagination
      :rowCount="rowCount"
      :pageCount="pageCount"
      @pageClick="onPageClick"
    />

    <div class="aiChatHistoryTable__table bookingDashboard__table">
      <div class="aiChatHistoryTable__table-header bookingDashboard__table-header">
        <div class="aiChatHistoryTable__table-cell bookingDashboard__table-cell">Title</div>
        <div class="aiChatHistoryTable__table-cell bookingDashboard__table-cell">User</div>
        <div class="aiChatHistoryTable__table-cell bookingDashboard__table-cell">Email</div>
        <div class="aiChatHistoryTable__table-cell bookingDashboard__table-cell">Created date</div>
        <div class="aiChatHistoryTable__table-cell bookingDashboard__table-cell">Updated date</div>
        <div class="aiChatHistoryTable__table-cell bookingDashboard__table-cell"></div>
      </div>

      <div class="aiChatHistoryTable__body bookingDashboard__table-body">
        <vue-scroll :ops="ops">
          <div
            v-for="item of dataList"
            :key="item.id"
            class="aiChatHistoryTable__table-row bookingDashboard__table-row"
          >
            <div class="aiChatHistoryTable__table-cell bookingDashboard__table-cell">
              {{ item.title }}
            </div>

            <div class="aiChatHistoryTable__table-cell bookingDashboard__table-cell">
              {{ item.userName }}
            </div>

            <div class="aiChatHistoryTable__table-cell bookingDashboard__table-cell">
              {{ item.email }}
            </div>

            <div class="aiChatHistoryTable__table-cell bookingDashboard__table-cell">
              {{ formatDate(item.createdAtUtc) }}
            </div>

            <div class="aiChatHistoryTable__table-cell bookingDashboard__table-cell">
              {{ formatDate(item.updatedAtUtc) }}
            </div>

            <div class="aiChatHistoryTable__table-cell bookingDashboard__table-cell">
              <router-link
                class="bookingDashboard__table-detail"
                :to="`/admin/ai-chat/${item.id}`"
              >
                click for details
              </router-link>
            </div>
          </div>
        </vue-scroll>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Pagination from '@/components/common/Pagination/Pagination'
import './AiChatHistoryTable.styl'

export default {
  name: 'AiChatHistoryTable',

  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
    rowCount: {
      type: Number,
      default: 0,
    },
    pageCount: {
      type: Number,
      default: 0,
    },
  },

  data: () => ({
    ops: {
      rail: {
        size: '3px',
      },
      bar: {
        size: '3px',
        background: 'rgba(0,0,0,0.1)',
      },
    },
  }),

  methods: {
    formatDate (date) {
      return date ? moment(date).format('M/D/YYYY HH:mm') : ''
    },

    onPageClick (data) {
      this.$emit('pageClick', data)
    },
  },

  components: {
    Pagination,
  },
}
</script>
